<div *ngIf="!registration_form_filled"
  class="w-full h-full flex justify-center items-center font-poppins animate-slideIn">
  <div class="w-full h-full flex justify-center items-center relative">
    <svg xmlns="http://www.w3.org/2000/svg" width="321" height="397" viewBox="0 0 321 397" fill="none"
      class="opacity-80 z-10">
      <path d="M320 1H1V396H5.20844H187.855L320 251.816V1Z" fill="url(#paint0_linear_1_56)" fill-opacity="0.8"
        stroke="white" />
      <defs>
        <linearGradient id="paint0_linear_1_56" x1="160.5" y1="81" x2="160.5" y2="396" gradientUnits="userSpaceOnUse">
          <stop stop-color="#1D2555" />
          <stop offset="1" stop-color="#05050C" />
        </linearGradient>
      </defs>
    </svg>
    <div class="absolute top-5 w-full flex justify-center items-center z-20">
      <form (ngSubmit)="register()" class="flex flex-col justify-center items-center">
        <div class="text-center w-full justify-center items-center space-y-3">
          
          <!-- Name field with error styling -->
          <div class="relative">
            <input type="text" placeholder="Enter name"
              class="bg-transparent text-white border-b-2 p-1 w-64 outline-none"
              [class.border-red-500]="hasError('name')"
              [class.border-white]="!hasError('name')"
              [(ngModel)]="name" name="name" required>
          </div>

          <!-- Email field with error styling -->
          <div class="relative mt-6">
            <input type="email" placeholder="Enter email"
              class="bg-transparent text-white border-b-2 p-1 w-64 outline-none"
              [class.border-red-500]="hasError('email')"
              [class.border-white]="!hasError('email')"
              [(ngModel)]="email" name="email" required>
          </div>

          <!-- Country field with error styling -->
          <div class="ml-[10%] w-[80%] text-white relative mt-6">
            <select [(ngModel)]="country" name="country" 
              aria-placeholder="Select Country"
              class="bg-blue-950/40 outline-0 w-full p-1 border-b-2"
              [class.border-red-500]="hasError('country')"
              [class.border-white]="!hasError('country')" required>
              <option [ngValue]="null" selected>Select Country</option>
              <option *ngFor="let country of countryOptions" [ngValue]="country">
                {{ country.name }}
              </option>
            </select>
          </div>

          <!-- Mobile field with error styling -->
          <div class="w-full flex justify-center items-center pt-1 pb-1 mt-6">
            <div class="flex w-[80%] justify-start items-center text-gray-400 border-b-2 relative"
                 [class.border-red-500]="hasError('mobile')"
                 [class.border-white]="!hasError('mobile')">
              <p class="mr-2">{{country?.country_code}} </p>
              <input type="text" placeholder="Enter mobile no."
                class="bg-transparent text-white p-1 outline-0 border-none"
                [attr.maxLength]="country?.mobile_number_length" 
                [attr.minLength]="country?.mobile_number_length"
                [(ngModel)]="mobile_no" name="mobile_no" required>
            </div>
          </div>

          <!-- Password field with error styling -->
          <div class="ml-[10%] w-[80%] flex items-center justify-between border-b-2 p-1 relative mt-6"
               [class.border-red-500]="hasError('password')"
               [class.border-white]="!hasError('password')">
            <input type="password" placeholder="Enter password" 
              class="bg-transparent text-white outline-none w-4/5"
              #passwordInput [(ngModel)]="password" name="password" minlength="8" required>
            <button type="button" class="text-white" (click)="togglePasswordVisibility(passwordInput)">
              <i *ngIf="!showPassword" class="fas fa-eye-slash"></i>
              <i *ngIf="showPassword" class="fas fa-eye"></i>
            </button>
          </div>
        </div>
        
        <div class="flex w-full flex-col">
          <!-- Updated register button with loading state -->
          <button
            [disabled]="isSubmitting"
            class="relative mt-3 h-12 w-64 bg-[#31a1f6] text-white font-poppins transform translate-x-[-0.5rem] translate-y-8 overflow-hidden hover:text-[#31a1f6] transition-colors duration-300 group disabled:opacity-50 disabled:cursor-not-allowed">
            <span *ngIf="!isSubmitting">Register</span>
            <span *ngIf="isSubmitting">Registering...</span>
            <span
              class="absolute top-0 left-0 h-full w-0 bg-white transition-all duration-300 group-hover:w-full z-[-1]"></span>
          </button>
          
          <button
            type="button"
            (click)="navigateToLogin()"
            class="relative mt-3 text-[13px] w-64 text-white font-poppins transform translate-x-[-1rem] translate-y-7 overflow-hidden group">
            Have an account? <span class="text-[#31a1f6] hover:text-blue-600 transition-colors duration-300">Login here</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<div *ngIf="registration_form_filled" class="w-full h-full flex justify-center items-center">
  <app-enter-otp [isForgotPasswordComponent]="false" [email]="this.email"></app-enter-otp>
</div>